import { PageData } from "types"
import { SectionDataParser } from "components/SectionDataParser"
import { useContext, useEffect } from "react"
import { sendTealiumEvent } from "tealium"
import {
  NextPageButton,
  PreviousPageButton,
} from "components/PageProgressButtons"
import { ClientContext } from "context/ClientContext"
import { Flex } from "@chakra-ui/react"

/**
 * A component for generating a page given the page data in JSON format
 *
 * @param pageData The JSON representing the page information
 * @returns The component representation of the page data
 */
export const PageDataParser = ({ pageData }: { pageData: PageData }) => {
  const { client } = useContext(ClientContext)

  useEffect(() => {
    sendTealiumEvent("page_view", {
      type: "view",
      page: `${pageData.slug}`
    })
  }, [pageData.slug])

  return (
    <>
      {pageData.sections.map((section, index) => {
        // The order of the sections is guaranteed to be the same as the order of the sections in the JSON file, so index is okay to use as a key. `section` has no required unique identifier.
        return <SectionDataParser key={index} sectionData={section} />
      })}
      <Flex
        justifyContent="space-between"
        pt={{ base: 6, md: 8 }}
        pb={{ base: 8, md: 12 }}
        px={4}
        mx={{ base: 2 }}
      >
        <PreviousPageButton
          currentPage={pageData}
          pages={client?.data?.pages ?? []}
        />
        <NextPageButton
          currentPage={pageData}
          pages={client?.data?.pages ?? []}
        />
      </Flex>
    </>
  )
}
